import { useMemo } from 'react'
import { toCustomerSelectOptions, toCustomerSelectOptionsParentFirst } from '../util/customerOptions.util'

/**
 * Memoized react-select options from customer entities.
 *
 * @param {Array} customers - customer entities (`id`, `customer_name`, optional `parent_id`)
 * @param {{ parentFirst?: boolean, mapExtra?: (customer: object) => object }} [options]
 * @returns {Array<{ value: *, label: string }>}
 */
const useCustomerOptions = (customers, { parentFirst = false, mapExtra } = {}) =>
  useMemo(() => {
    const toOptions = parentFirst ? toCustomerSelectOptionsParentFirst : toCustomerSelectOptions
    return toOptions(customers, mapExtra)
  }, [customers, parentFirst, mapExtra])

export default useCustomerOptions
